module.exports = __webpack_public_path__ + "img/P07-AR2008-Z103-19.9a6ee92b.jpg";